function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsercircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18.564 19.277A9.775 9.775 0 0021.8 12c0-5.412-4.388-9.8-9.8-9.8-5.412 0-9.8 4.388-9.8 9.8a9.775 9.775 0 003.256 7.296A9.764 9.764 0 0012 21.8c2.516 0 4.81-.948 6.545-2.506l.019-.017zM12 3.8a8.2 8.2 0 00-6.172 13.6 7.552 7.552 0 013.29-2.629 4.55 4.55 0 115.763 0 7.543 7.543 0 013.29 2.628A8.2 8.2 0 0012 3.8zm4.99 14.707a5.951 5.951 0 00-9.98 0C8.392 19.57 10.122 20.2 12 20.2s3.608-.631 4.99-1.693zM12 14.2a2.95 2.95 0 100-5.9 2.95 2.95 0 000 5.9z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgUsercircle;